import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useLiterals } from '~/components/Literals'
import actions, { TYPES } from '../actions'
import api from '../api'

function StoresPage({ position, match }) {
  const dispatch = useDispatch()
  const history = useHistory()
  const { getLiteral } = useLiterals()

  const handleSearchStores = async (gtins) => {
    const searchParams = position.getParams()

    dispatch(actions.updateApp({ storesLoading: true, view: TYPES.VIEW_STORES }))

    try {
      const { stores, products } = await api.getStores({ ...searchParams, gtins })

      dispatch(actions.storesSuccess({ stores, storesFetched: gtins, selected: products }))
    } catch (error) {
      const emptyStores = error.message === 'empty_stores'
      const undefinedPosition = !(position.user?.lat && position.user?.lng)
      let message = getLiteral('2099')

      if (emptyStores) {
        message = getLiteral('2100')
      }

      if (undefinedPosition) {
        message = getLiteral('2098')
      }

      if (emptyStores || undefinedPosition) history.replace('/')
      dispatch(actions.snack.add({ id: Date.now(), message }))
    }
  }

  useEffect(() => {
    const gtins = match.params.gtins.split(',').map((i) => i.trim())

    // if (!position.fetched) {
    //   position.fetchPosition()
    //   return
    // }

    handleSearchStores(gtins)
  }, [match.params.gtins, position.fetched])

  return null
}

export default StoresPage
